import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import TrashIcon from "components/Icons/TrashIcon";
import type { OneRepMaxEntriesTableRow } from "../hooks/useOneRepMaxEntriesTableRows";
import { OneRepMaxTableAction } from ".";

interface OneRepMaxEntryDeleteButtonProps {
  row: OneRepMaxEntriesTableRow;
  onClick: (row: OneRepMaxEntriesTableRow) => void;
  registerButton: (id: string, node: HTMLButtonElement | null) => void;
}

function OneRepMaxEntryDeleteButton(props: OneRepMaxEntryDeleteButtonProps) {
  const { row, onClick, registerButton } = props;
  const { t } = useTranslation();

  const ref = useCallback((node: HTMLButtonElement | null) => registerButton(row.id, node), [registerButton, row.id]);
  const handleClick = useCallback(() => onClick(row), [onClick, row]);

  return (
    <OneRepMaxTableAction
      ref={ref}
      size="small"
      title={t("global.delete_button_text")}
      aria-label={t("charting.one_rep_max_table_delete_entry", { entry: row.summary })}
      color="error"
      onClick={handleClick}
    >
      <TrashIcon fontSize="small" />
    </OneRepMaxTableAction>
  );
}

export default memo(OneRepMaxEntryDeleteButton);
